export default "__VITE_ASSET__XrfCqoxR__"